import { render } from "./VvTextarea.vue?vue&type=template&id=561507fe"
import script from "./VvTextarea.vue?vue&type=script&lang=js"
export * from "./VvTextarea.vue?vue&type=script&lang=js"

import "./VvTextarea.vue?vue&type=style&index=0&id=561507fe&lang=css"

import exportComponent from "F:\\projects\\Cloutlayer\\Cloutlayer\\Source\\webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__